import Server from './../../libs/server'

const state = {
    account: {
        account: {
            login: false,
            packet_name: false,
            packet_expire: false
        },
        settings: {
            stream_server: {value: '', list: []},
            timeshift: {value: '', list: []},
            http_caching: {value: '', list: []},
            stream_standard: {value: 'hls_h264'}
        },
    }
};

const actions = {
    resetLogin({commit, dispatch}) {
        commit('RESET_LOGIN');
    },
    makeLogin({commit, dispatch}, {abo, pass}) {
        return new Promise((resolve, reject) => {
            Server.login(abo, pass, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        resolve();
                    }
                }
            });
        });
    },
    makeLogout({commit, dispatch}) {
        return new Promise((resolve, reject) => {
            Server.logout((err, data) => {
                if (err) {
                    console.error(err.message)
                } else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        commit('LOGOUT_OK');
                        resolve();
                    }
                }
            })
        });
    },
    getAccount({commit, dispatch}) {
        return new Promise((resolve, reject) => {
            Server.getAccount((err, data) => {
                if (err) {
                    console.error(err.message)
                } else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        commit('GET_ACCOUNT_OK', data);
                        resolve();
                    }
                }
            });
        });
    },
    changeSetting({commit, dispatch}, {key, value}) {
        commit('SET_SETTING', {key, value});
    }
};

const mutations = {
    LOGOUT_OK(state) {
        state.account.account.login = false;
    },

    GET_ACCOUNT_OK(state, account) {
        state.account = account
    },
    RESET_LOGIN(state) {
        state.account.account.login = '';
    },
    SET_SETTING(state, {key, value}) {
        state.account.settings[key].value = value;
    }
};

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js